export const downloadCSV = (data: any) => {
  console.log("Downloading CSV with data:", data);
  if (!data || typeof data !== "object" || !data?.reportData?.report) {
    console.error("Invalid data format for CSV export");
    return;
  }

  const report = data?.reportData?.report;
  const summary = JSON.parse(data?.processed?.chatData?.data?.response);

  console.log("Downloading CSV with report:", report);
  console.log("Downloading CSV with summary:", summary);

  // Extract headers from report object
  const headers = Object.keys(report);
  const values = Object.values(report);

  // Prepare safe CSV value for summary
  let summaryText = summary?.answer || "No summary available";

  // Replace newlines with Excel-compatible newlines
  summaryText = summaryText.replace(/\n/g, "\r\n");

  // Escape quotes by doubling them and wrap the whole thing in quotes
  const safeSummary = `"${summaryText.replace(/"/g, '""')}"`;

  // Append 'Summary' column
  headers.push("Summary");
  values.push(safeSummary);

  const csvContent = `${headers.join(",")}\n${values.join(",")}`;

  // Create Blob and trigger download
  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");

  a.href = url;
  a.download = "unit_report.csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
